import React, { useState, useEffect } from "react";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";
import ServiceAdmin from "./AdminService/ServiceAdmin";
import { formatSpecailiteToLabelValue } from "../utils/utils";
import Select, { components } from "react-select";
//
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
//
function ModalUpAdmin(props) {
  //get data from program
  const { showAdmin, toggleAdmin, idAdmin, infos } = props;
  //
  const row = infos.filter((x) => x.id === idAdmin);
  //console.log("this is up data: ", infos);
  //
  useEffect(() => {
    adminData();
  }, [idAdmin]);
  //
  const [formattedspecailite, setFormattedSpecailite] = useState();
  const [speciality, setSpeciality] = useState("");
  const [firstName, setfirstName] = useState("");
  const [cin, setCin] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [adresse, setAdresse] = useState("");
  const [role, setRole] = useState("");

  const adminData = () => {
    row.map((admin) => {
      setfirstName(admin.firstName);
      setlastName(admin.lastName);
      setCin(admin.cin);
      setEmail(admin.email);
      setAdresse(admin.adresse);
      setTel(admin.tel);
      setSpeciality(
        admin.role === "ADMIN" && admin.speciality
          ? admin.speciality.designation
          : ""
      );
      setRole(admin.role);
      //console.log("this is a spe ", admin.speciality.designation);
    });
  };

  // console.log(
  //   speciality,
  //   lastName,
  //   firstName,
  //   cin,
  //   tel,
  //   email,
  //   adresse
  // );

  console.log("role-->", role);

  useEffect(() => {
    GetSpecailite();
  }, []);

  const GetSpecailite = () => {
    ServiceAdmin.getSpeciality().then((res) => {
      setFormattedSpecailite(res.data.map(formatSpecailiteToLabelValue));
      //console.log(res.data);
    });
  };

  const ChangeAdminInfos = (e) => {
    ServiceAdmin.updateAdminInfos(
      idAdmin,
      firstName,
      lastName,
      cin,
      adresse,
      tel,
      email,
      role
    ).then((res) => {
      //   window.location.reload();
      //   window.location.replace("/XXXXXXXXXX");
    });
  };

  //   console.log("this is a role ", row && row[0].role);
  return (
    <>
      <Modal show={showAdmin} onHide={toggleAdmin} size="sx">
        <Modal.Body>
          <div className="container upData">
            <img
              alt="close modal"
              src="https://img.icons8.com/fluent/48/000000/close-window.png"
              style={{ float: "right" }}
              onClick={() => toggleAdmin()}
            />

            <h2>Details patient</h2>
            <hr />

            <form className="admin" onSubmit={() => ChangeAdminInfos()}>
              <Row>
                <Col lg={6} sm={12}>
                  <Form.Control
                    type="text"
                    placeholder="Nom"
                    value={firstName}
                    onChange={(e) => setfirstName(e.target.value)}
                    required
                    disabled
                  />
                </Col>
                <Col lg={6} sm={12}>
                  <Form.Control
                    type="text"
                    placeholder="Prénom"
                    value={lastName}
                    onChange={(e) => setlastName(e.target.value)}
                    required
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Cin"
                    value={cin}
                    onChange={(e) => setCin(e.target.value)}
                    required
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Adress"
                    value={adresse}
                    onChange={(e) => setAdresse(e.target.value)}
                    required
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Téléphone"
                    value={tel}
                    onChange={(e) => setTel(e.target.value)}
                    required
                    disabled
                  />
                </Col>
              </Row>
              {/* {row.length && row[0].role == "ADMIN" && (
                <Row>
                  <Col>
                    <Select
                      placeholder="Votre spécialité"
                      width="90%"
                      styles={{
                        singleValue: (base) => ({
                          ...base,
                          padding: 5,
                          borderRadius: 5,
                          color: "white",
                          display: "flex",
                          color: "black",
                        }),
                      }}
                      isClearable
                      components={{ SingleValue }}
                      isSearchable
                      name="label"
                      defaultValue={`"${speciality}"`}
                      options={formattedspecailite}
                      onChange={(formattedspecailite) => {
                        setSpeciality(formattedspecailite);
                      }}
                      required
                    />
                  </Col>
                </Row>
              )} */}
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Adresse email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    //required
                    disabled
                  />
                </Col>
              </Row>
              {infos.length > 0 && infos[0].role === "SUPER_ADMIN" && (
                <>
                  <Row>
                    <Col>
                      <Form.Group controlId="calendar.SelectCustom">
                        <Form.Control
                          as="select"
                          custom
                          required
                          value={role}
                          onChange={(e) => {
                            setRole(e.target.value);
                          }}
                        >
                          <option>ADMIN</option>
                          <option>USER</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button className="updateBtn" type="submit">
                        Modifier
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
              {/* <Row>
                <Col>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Col>
              </Row> */}
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalUpAdmin;
